import {
  ROOT,
  GET_CANCELLATION_POLICY,
  UPDATE_CANCELLATION_POLICY,
  CREATE_CANCELLATION_POLICY,
  DELETE_CANCELLATION_POLICY
} from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function get(params) {
  return fetch(
    ROOT +
      GET_CANCELLATION_POLICY +
      `?limit=${params.limit}&offset=${params.offset}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_CANCELLATION_POLICY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function insert(data) {
  return fetch(ROOT + CREATE_CANCELLATION_POLICY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function remove(id) {
  return fetch(
    ROOT + DELETE_CANCELLATION_POLICY + `/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
export const service = {
  get,
  update,
  insert,
  remove
};
